import React from "react";
import ProductTemplate from "../../ProductTemplate";
import rehauCover from "../../../assets/rehau/RehauCover.png";
import rehaub from "../../../assets/rehau/rehaub.jpg";
import rehauc from "../../../assets/rehau/rehauc.jpg";
import rehau1 from "../../../assets/rehau/rehau1.webp";
import rehau2 from "../../../assets/rehau/rehau2.webp";
import rehau3 from "../../../assets/rehau/rehau3.webp";
import rehau4 from "../../../assets/rehau/rehau4.webp";
import rehau5 from "../../../assets/rehau/rehau5.webp";
import rehau6 from "../../../assets/rehau/rehau6.webp";
import rehau7 from "../../../assets/rehau/rehau7.webp";
import rehau8 from "../../../assets/rehau/rehau8.webp";
import rehau9 from "../../../assets/rehau/rehau9.webp";


const Rehau = () => {
  const data = {
    title: "REHAU Windows",
    subtitle: "High-performance uPVC Window Systems",
    description:
      "REHAU window systems are designed to meet the highest standards of energy efficiency, sound insulation, and security. With a modern design and advanced technology, they are ideal for residential and commercial applications.",
    specifications: [
      { label: "WINDOW TYPE", value: "UPVC Hinged & Sliding" },
      { label: "FRAME DEPTH", value: "70 mm" },
      { label: "U-VALUE", value: "from 0.8 to 1.3 W/m²K" },
      { label: "BURGLAR RESISTANCE", value: "RC2" },
      { label: "WATER TIGHTNESS", value: "CLASS E1200" },
      { label: "AIR PERMEABILITY", value: "CLASS 4" },
      { label: "MAXIMUM GLAZING THICKNESS", value: "up to 50 mm" },
    ],
    renders: [rehauCover, rehaub, rehauc],
    typologies: [
        { image: rehau1, caption: "Odd number of vents on one side" },
            { image: rehau2, caption: "Odd number of vents plus door" },
            { image: rehau3, caption: "Odd number of vents on both sides (meeting stile)" },
            { image: rehau4, caption: "Odd number of vents on one side" },
            { image: rehau5, caption: "Corner construction with single door" },
            { image: rehau6, caption: "Corner construction with odd number of vents on both sides" },
            { image: rehau7, caption: "Odd number of vents on both sides (meeting stile)" },
            { image: rehau8, caption: "Even number of vents on one side" },
            { image: rehau9, caption: "Even number of vents plus door" },
    ],
    sections: [],
    relatedFiles: [
      {
        label: "Rehau System Specs",
        link: "https://www.rehau.com/docs/system-specs.pdf",
      },
      {
        label: "Rehau Brochure",
        link: "https://www.rehau.com/docs/brochure.pdf",
      },
    ],
  };

  return <ProductTemplate {...data} />;
};

export default Rehau;